import React from 'react';
import PropTypes from "prop-types";
import Button from '../../components/Button';
import ButtonGroup from '../../components/ButtonGroup';
import Form from '../../components/Form';
import Paper from '../../components/Paper';
import Typography from '../../components/Typography';
import { makeStyles } from '../../utils/styles';
import { preventDefault } from '../../utils/helpers';
import Loader from '../../components/Loader';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles(css => ({
    paper: css`
        position: relative;
        overflow: hidden;
        max-width: 400px;
    `,
    typography: css`
        margin-bottom: 20px;
    `,
    buttonGroup: css`
        justify-content: center;
    `
}))

const FormConfirmDelete = ({ loading, onClickCancel, onSubmit }) => {
    const { t } = useTranslation()
    const styles = useStyles();
    const handleSubmit = e => {
        preventDefault(e);
        onSubmit();
    };
    return (
        <Paper customStyle={styles.paper}>
            <Form onSubmit={handleSubmit}>
                <Typography as="h1" customStyle={styles.typography} align="center">
                    {t("Czy na pewno usunać?")}
                </Typography>
                <ButtonGroup gutters={20} customStyle={styles.buttonGroup}>
                    <Button
                        variant="text"
                        onClick={onClickCancel}
                    >
                        {t("Anuluj")}
                    </Button>
                    <Button
                        type="submit"
                        disabled={loading}
                    >
                        {t("Potwierdź")}
                    </Button>
                </ButtonGroup>
            </Form>
            <Loader show={loading} />
        </Paper>
    )
};

FormConfirmDelete.propTypes = {
    loading: PropTypes.bool,
    onClickCancel: PropTypes.func,
    onSubmit: PropTypes.func
};

export default FormConfirmDelete;
